import React, { Component } from 'react';

import classnames from 'classnames';
import { GroupedCards } from 'components/groupedCards';
import PropTypes from 'prop-types';

import './UserCard.scss';

class UserCard extends Component {
  static propTypes = {
    t: PropTypes.func,
    title: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.object,
    footer: PropTypes.object,
    value: PropTypes.string,
    index: PropTypes.number
  };

  render() {
    const { title, value, className, children, footer, index } = this.props;
    const parentClassNames = classnames('user_card__content', className);

    return (
      <GroupedCards.Item className={parentClassNames} index={index}>
        <div className="labeled" data-test="labeled">
          <label data-test="labeled-title">{title}</label>
          <div className="user_card__body">
            <span className="user_card__total" data-test="card-value">
              {value}
            </span>
            {children}
          </div>
          {footer && <footer className="user_card__footer">{footer}</footer>}
        </div>
      </GroupedCards.Item>
    );
  }
}

export default UserCard;
